import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { BaseView } from '@wizeoo/akm-common-lib';


/**
 * Le state de navigation vers la vue Fallback
 */
export type FallbackViewState = {
  
  redirectFrom: string; // la vue d'origine de la demande de navigation 
  redirectTo: string;// La vue vers laquelle l'utilisateur doit être redirigé aprés le choix de son contexte

};


/**
 * Vue de fallback. L'utilisateur attéri sur cette vue lorsque ces paramètres d'entrées dans l'application sont incohérents. (DOM, BU, VISION...)
 */
@Component({
  selector: 'fallback-view',
  templateUrl: './fallback.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FallbackView extends BaseView {


  constructor(public elementRef: ElementRef) {
    super(elementRef);
  }
}
